var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _g, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUgv(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 18,
    viewBox: "0 0 33 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6534 11.1857H21.293L18.438 6.28854L13.1323 5.70068C11.7658 5.70068 10.6582 6.73755 10.6582 8.01679V11.1857H10.6534Z",
    fill: "url(#paint0_linear_5146_52530)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.24167 5.70074H7.15625V7.77474H3.24167V5.70074Z",
    fill: "url(#paint1_linear_5146_52530)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.84598 4.54739H16.8086L15.618 3.07104H2.61146C2.52487 3.07104 2.45632 3.13864 2.45632 3.22402V4.16674C2.45993 4.37663 2.63311 4.54739 2.84598 4.54739Z",
    fill: "url(#paint2_linear_5146_52530)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.81729 6.59303H5.37891V4.55106H2.83172C2.62607 4.55106 2.46011 4.7147 2.46011 4.91747V6.2444C2.46011 6.4365 2.61885 6.59303 2.81729 6.59303Z",
    fill: "url(#paint3_linear_5146_52530)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.6311 4.54764H5.06948V6.58961H7.61667C7.82232 6.58961 7.98828 6.42597 7.98828 6.2232V4.89627C7.98828 4.70417 7.82593 4.54764 7.6311 4.54764Z",
    fill: "url(#paint4_linear_5146_52530)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.35198 7.44705H8.70312V8.6388H4.35198V7.44705Z",
    fill: "url(#paint5_linear_5146_52530)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.35485 8.63898H18.0469V12.8759H4.35485V8.63898Z",
    fill: "url(#paint6_linear_5146_52530)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.727 16.3586C13.3239 16.3586 11.3758 14.4378 11.3758 12.0684C11.3758 9.6989 13.3239 7.77808 15.727 7.77808C18.1301 7.77808 20.0781 9.6989 20.0781 12.0684C20.0781 14.4378 18.1301 16.3586 15.727 16.3586Z",
    fill: "url(#paint7_linear_5146_52530)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7274 14.5758C14.2868 14.5758 13.1189 13.4243 13.1189 12.0038C13.1189 10.5833 14.2868 9.43176 15.7274 9.43176C17.1681 9.43176 18.3359 10.5833 18.3359 12.0038C18.3359 13.4243 17.1681 14.5758 15.7274 14.5758Z",
    fill: "#464649"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.726 13.0787C15.1282 13.0787 14.6435 12.6008 14.6435 12.0113C14.6435 11.4217 15.1282 10.9438 15.726 10.9438C16.3239 10.9438 16.8086 11.4217 16.8086 12.0113C16.8086 12.6008 16.3239 13.0787 15.726 13.0787Z",
    fill: "#18181B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1.28123 11.1858H4.35156V6.92398H1.357C1.3137 6.92398 1.28123 6.956 1.28123 6.99869V11.1858Z",
    fill: "url(#paint8_linear_5146_52530)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M3.7806 4.54764H5.37891V8.63871H3.7806V4.54764Z",
    fill: "url(#paint9_linear_5146_52530)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M4.58156 0.638184H5.37891V3.07504H4.58156V0.638184Z",
    fill: "url(#paint10_linear_5146_52530)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M4.35198 16.3586C1.94892 16.3586 0.000844955 14.4378 0.000844955 12.0684C0.000844955 9.6989 1.94892 7.77808 4.35198 7.77808C6.75505 7.77808 8.70312 9.6989 8.70312 12.0684C8.70312 14.4378 6.75505 16.3586 4.35198 16.3586Z",
    fill: "url(#paint11_linear_5146_52530)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M4.35095 14.5765C2.94617 14.5765 1.80738 13.4536 1.80738 12.0685C1.80738 10.6834 2.94617 9.56049 4.35095 9.56049C5.75573 9.56049 6.89453 10.6834 6.89453 12.0685C6.89453 13.4536 5.75573 14.5765 4.35095 14.5765Z",
    fill: "#464649"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M4.35056 13.0898C3.78261 13.0898 3.3222 12.6358 3.3222 12.0758C3.3222 11.5158 3.78261 11.0619 4.35056 11.0619C4.9185 11.0619 5.37891 11.5158 5.37891 12.0758C5.37891 12.6358 4.9185 13.0898 4.35056 13.0898Z",
    fill: "#18181B"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5146_52530",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 3,
    width: 7,
    height: 2
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5257 3.36453H5.21875V4.25106H11.5257V3.36453Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5146_52530)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.21875 4.24669V3.36453H5.90525L6.12228 3.54795V4.06327L5.90525 4.24669H5.21875ZM5.48892 4.07637H5.79453L5.86982 4.01523V3.59599L5.79453 3.53485H5.48892V4.07637Z",
    fill: "#18181B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.60866 4.24669L7.44922 4.11567V3.49555L7.60866 3.36453H8.2243L8.38375 3.49555V4.11131L8.2243 4.24232L7.60866 4.24669ZM7.77254 4.07637H8.07371L8.12244 4.0327V3.57852L8.06929 3.53485H7.77254L7.72382 3.57852V4.03707L7.77254 4.07637Z",
    fill: "#18181B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.62891 4.24669V3.36453H9.33313L9.49257 3.49555V3.83618L9.33313 3.96719H8.89908V4.24669H8.62891ZM8.89465 3.80124H9.18254L9.23126 3.75757V3.57852L9.18254 3.53485H8.89465V3.80124Z",
    fill: "#18181B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.68359 4.24669V3.36453H9.94934V4.06764H10.3524L10.2859 4.25106H9.68359V4.24669Z",
    fill: "#18181B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2245 3.36453H10.7905L10.4805 4.25106H10.7639L10.8082 4.09821L11.167 3.97593L11.1935 4.072L11.2467 4.24669H11.5302L11.2245 3.36453ZM10.9145 3.74447L10.981 3.53048H11.0297L11.1138 3.80561L10.8702 3.88859L10.9145 3.74447Z",
    fill: "#18181B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.00159 4.24669H7.27176L7.11231 3.91479L7.2319 3.81434V3.49555L7.07245 3.36453H6.35938V4.24669H6.62512V4.0327L6.86872 3.94972L7.00159 4.24669ZM6.62069 3.53485H6.92187L6.97058 3.57852V3.73574L6.62069 3.85365V3.53485Z",
    fill: "#18181B"
  })))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1953 13.1172L18.7365 4.5473H16.8109L22.4103 13.4125L24.1953 13.1172Z",
    fill: "url(#paint12_linear_5146_52530)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7712 14.5078L28.6328 14.1364L28.6328 11.9893L26.5416 11.7345L26.7712 14.5078Z",
    fill: "url(#paint13_linear_5146_52530)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8426 13.0858L24.5766 14.685L23.1992 16.5443L33.0752 14.3758L31.8426 13.0858Z",
    fill: "url(#paint14_linear_5146_52530)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M22.593 12.6011L31.0539 11.9995C31.4263 11.977 31.8971 11.4177 32.0929 10.7566L22.9236 11.2994L22.593 12.6011Z",
    fill: "url(#paint15_linear_5146_52530)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7266 7.77438V8.46453",
    stroke: "#464649",
    strokeWidth: 0.640881,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7305 7.77438V8.46453",
    stroke: "#464649",
    strokeWidth: 0.640881,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3945 8.10132L17.1275 8.7381",
    stroke: "#464649",
    strokeWidth: 0.640881,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8047 9.03372L18.314 9.52109",
    stroke: "#464649",
    strokeWidth: 0.640881,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M19.75 10.4286L19.1042 10.6918",
    stroke: "#464649",
    strokeWidth: 0.640881,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0781 12.0708L19.3818 12.0673",
    stroke: "#464649",
    strokeWidth: 0.640881,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7461 13.7118L19.1003 13.4485",
    stroke: "#464649",
    strokeWidth: 0.640881,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8008 15.1026L18.3101 14.6153",
    stroke: "#464649",
    strokeWidth: 0.640881,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3906 16.0318L17.1236 15.3985",
    stroke: "#464649",
    strokeWidth: 0.640881,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7227 16.3582V15.6716",
    stroke: "#464649",
    strokeWidth: 0.640881,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0572 16.0312L14.3242 15.3944",
    stroke: "#464649",
    strokeWidth: 0.640881,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6463 15.0999L13.1406 14.6125",
    stroke: "#464649",
    strokeWidth: 0.640881,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7057 13.7042L12.3516 13.4445",
    stroke: "#464649",
    strokeWidth: 0.640881,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3743 12.0652H12.0742",
    stroke: "#464649",
    strokeWidth: 0.640881,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7094 10.4211L12.3516 10.6844",
    stroke: "#464649",
    strokeWidth: 0.640881,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6502 9.0303L13.1445 9.51767",
    stroke: "#464649",
    strokeWidth: 0.640881,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M14.065 8.10132L14.332 8.73455",
    stroke: "#464649",
    strokeWidth: 0.640881,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M4.35156 7.77438V8.46453",
    stroke: "#464649",
    strokeWidth: 0.640881,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M4.35547 7.77438V8.46453",
    stroke: "#464649",
    strokeWidth: 0.640881,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M6.02344 8.10132L5.75284 8.7381",
    stroke: "#464649",
    strokeWidth: 0.640881,
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M7.43359 9.03372L6.93931 9.52109",
    stroke: "#464649",
    strokeWidth: 0.640881,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M8.375 10.4286L7.72918 10.6918",
    stroke: "#464649",
    strokeWidth: 0.640881,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M8.70312 12.0708L8.0068 12.0673",
    stroke: "#464649",
    strokeWidth: 0.640881,
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M8.37109 13.7118L7.72888 13.4485",
    stroke: "#464649",
    strokeWidth: 0.640881,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M7.42578 15.1026L6.9351 14.6153",
    stroke: "#464649",
    strokeWidth: 0.640881,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M6.01562 16.0318L5.74864 15.3985",
    stroke: "#464649",
    strokeWidth: 0.640881,
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M4.34766 16.3582V15.6716",
    stroke: "#464649",
    strokeWidth: 0.640881,
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M2.68614 16.0312L2.95312 15.3944",
    stroke: "#464649",
    strokeWidth: 0.640881,
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M1.27134 15.0999L1.76562 14.6125",
    stroke: "#464649",
    strokeWidth: 0.640881,
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M0.330746 13.7042L0.976562 13.4445",
    stroke: "#464649",
    strokeWidth: 0.640881,
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M0.00289232 12.0652H0.699219",
    stroke: "#464649",
    strokeWidth: 0.640881,
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M0.334352 10.4211L0.976562 10.6844",
    stroke: "#464649",
    strokeWidth: 0.640881,
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M1.27885 9.0303L1.76953 9.51767",
    stroke: "#464649",
    strokeWidth: 0.640881,
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M2.69005 8.10132L2.95703 8.73455",
    stroke: "#464649",
    strokeWidth: 0.640881,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5146_52530",
    x1: 16.3357,
    y1: 2.64094,
    x2: 15.0635,
    y2: 11.1015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.366959,
    stopColor: "#363636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641552,
    stopColor: "#7B7B7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.692372,
    stopColor: "#7B7B7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#363636"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5146_52530",
    x1: 7.15638,
    y1: 6.73739,
    x2: 3.24082,
    y2: 6.73739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.255,
    stopColor: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#787878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765,
    stopColor: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1B1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5146_52530",
    x1: 9.63545,
    y1: 4.65089,
    x2: 9.63545,
    y2: 2.93608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3234,
    stopColor: "#525252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6218,
    stopColor: "#989898"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9095,
    stopColor: "#525252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171717"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5146_52530",
    x1: 5.379,
    y1: 5.57169,
    x2: 2.45947,
    y2: 5.57169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.255,
    stopColor: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765,
    stopColor: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1B1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5146_52530",
    x1: 7.98838,
    y1: 5.56828,
    x2: 5.06885,
    y2: 5.56828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.255,
    stopColor: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765,
    stopColor: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1B1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5146_52530",
    x1: 8.70327,
    y1: 8.04272,
    x2: 4.35104,
    y2: 8.04272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.255,
    stopColor: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765,
    stopColor: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1B1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5146_52530",
    x1: 11.1983,
    y1: 13.1714,
    x2: 11.1983,
    y2: 8.86499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#363636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5522,
    stopColor: "#7B7B7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7511,
    stopColor: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8924,
    stopColor: "#7B7B7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#363636"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_5146_52530",
    x1: 15.0722,
    y1: 17.6301,
    x2: 11.4464,
    y2: 12.0201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.255,
    stopColor: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765,
    stopColor: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1B1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_5146_52530",
    x1: 4.35166,
    y1: 9.05416,
    x2: 1.28056,
    y2: 9.05416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.255,
    stopColor: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#787878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765,
    stopColor: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1B1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_5146_52530",
    x1: 5.37787,
    y1: 6.5933,
    x2: 3.78128,
    y2: 6.5933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#242324"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#797979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#242324"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_5146_52530",
    x1: 5.37787,
    y1: 1.85654,
    x2: 4.57958,
    y2: 1.85654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3234,
    stopColor: "#797979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6218,
    stopColor: "#D1D1D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9095,
    stopColor: "#797979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#434343"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_5146_52530",
    x1: 6.22457,
    y1: 17.1627,
    x2: 0.0706832,
    y2: 11.9817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.255,
    stopColor: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765,
    stopColor: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1B1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_5146_52530",
    x1: 24.1956,
    y1: 8.97836,
    x2: 16.8093,
    y2: 8.97836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.255,
    stopColor: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#787878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765,
    stopColor: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1B1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_5146_52530",
    x1: 28.6329,
    y1: 13.1207,
    x2: 26.5412,
    y2: 13.1207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.255,
    stopColor: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#787878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765,
    stopColor: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1B1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_5146_52530",
    x1: 23.6888,
    y1: 14.6118,
    x2: 32.4542,
    y2: 16.8338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.255,
    stopColor: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#787878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765,
    stopColor: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1B1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_5146_52530",
    x1: 30.9967,
    y1: 13.2581,
    x2: 23.5409,
    y2: 9.91738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.255,
    stopColor: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#787878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765,
    stopColor: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1B1B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUgv);
export default __webpack_public_path__ + "static/media/ugv.ff92256485d39292f37db0b513668434.svg";
export { ForwardRef as ReactComponent };